<template>
  <div class="canal needResize" :class="{'fullscreen': fullscreen}" v-if="result">
    <Info @fullscreen="onFullScreen" title="canal.title" text="canal.info" ></Info>
    <div class="title">
      <h3>{{$t('canal.title')}}</h3>
      <h2>{{$t('canal.description')}}</h2>
    </div>
    <div class="main-content-canal" :class="{'full': fullscreen}" ref="mainContent">
      <GChart
        v-if="chartData.length > 1"
        type="ColumnChart"
        :data="chartData"
        :options="chartOptions"
      />
      <div v-else class="no-data">
        {{ $t('no_data') || 'Aucune donnée disponible' }}
      </div>
    </div>
  </div>
</template>

<script>
  import Info from './Info.vue'
  export default {
    name: 'Canal',
    components: {
      Info
    },
    props: {
      result: Object, 
      nbOfColumns: Number
    },
    watch: {
      result: {
        handler() {
          this.$nextTick(() => {
            this.refresh()
          })
        },
        deep: true
      }, 
      nbOfColumns() {
        this.refresh(true)
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.refresh()
      })
    },
    data() {
      return {
        fullscreen: false,
        chartOptions: {
          colors: ["#5FE3A1", "#FF6565"], 
          width: '100%', 
          height: 300,
          legend: 'top',
          chartArea: { width: '80%', height: '70%' }
        },
        myWidth: 0,
        myHeight: 0
      }
    },
    computed: {
      chartData(){
        if (this.result && this.result.aggregations && this.result.aggregations.optin_print && this.result.aggregations.optin_sms && this.result.aggregations.optin_email) {
          let aggregations = this.result.aggregations
          return [
            [this.$t('canal.canal') || 'Canal', this.$t('canal.optin') || 'Optin', this.$t('canal.notOptin') || 'Non-Optin'],
            [this.$t('canal.print') || 'Print', this.getOptinDocCount(aggregations.optin_print.buckets, 1),this.getOptinDocCount(aggregations.optin_print.buckets, 0)],
            [this.$t('canal.sms') || 'SMS', this.getOptinDocCount(aggregations.optin_sms.buckets, 1),this.getOptinDocCount(aggregations.optin_sms.buckets, 0)],
            [this.$t('canal.email') || 'Email', this.getOptinDocCount(aggregations.optin_email.buckets, 1), this.getOptinDocCount(aggregations.optin_email.buckets, 0)]
          ]
        }
        return []
      }
    },
    methods: {
      onFullScreen() {
        this.fullscreen = !this.fullscreen
        this.$nextTick(() => {
          this.refresh()
        })
      }, 
      getOptinDocCount (buckets, value) {
        if (!buckets) return 0
        let candidates = buckets.filter(b => b.key === value)
        return candidates.length === 1 ? candidates[0].doc_count : 0
      }, 
      refresh (forceRefresh) {
        if (!this.$refs.mainContent) return

        if(this.myHeight == 0 || forceRefresh === true) {
          this.myHeight = this.$refs.mainContent.clientHeight - 4
          this.myWidth = this.$refs.mainContent.clientWidth
        }
        if (this.fullscreen) {
          this.chartOptions.width = "70vw"
          this.chartOptions.height = "70vh"
        } else {
          this.chartOptions.width = this.myWidth > 0 ? `${this.myWidth}px` : '100%'
          this.chartOptions.height = this.myHeight > 0 ? `${this.myHeight}px` : 300
        }
      }
    },
    created() {
      let that = this
      this.$emit("refreshedChart")
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/components/canal.sass";
  .canal {
    display: flex;
    flex-direction: column;
  }
  .main-content-canal {
    flex: 1;
    min-height: 300px;
    display: block; // Changed from flex to block for GChart sizing
  }
</style>
